import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // Check credentials
    // Super Admin: superadmin / super123
    // Regular Admin: admin / admin123
    if (username === 'superadmin' && password === 'super123') {
      sessionStorage.setItem('isAdminLoggedIn', 'true');
      sessionStorage.setItem('isSuperAdmin', 'true');
      sessionStorage.setItem('currentUser', JSON.stringify({
        username: 'superadmin',
        name: 'Super Administrator',
        email: 'superadmin@mh-training.com'
      }));
      onLogin();
      navigate('/');
    } else if (username === 'admin' && password === 'admin123') {
      sessionStorage.setItem('isAdminLoggedIn', 'true');
      sessionStorage.setItem('isSuperAdmin', 'false');
      sessionStorage.setItem('currentUser', JSON.stringify({
        username: 'admin',
        name: 'Administrator',
        email: 'admin@mh-training.com'
      }));
      onLogin();
      navigate('/');
    } else {
      setError('Invalid username or password');
    }

    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="login-icon">🔐</div>
          <h1 className="login-title">Admin Login</h1>
          <p className="login-subtitle">Training Management System</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {error && (
            <div className="login-error">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
              required
              autoFocus
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              required
            />
          </div>

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>

      <div className="public-access-notice">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="16" x2="12" y2="12"></line>
          <line x1="12" y1="8" x2="12.01" y2="8"></line>
        </svg>
        <div>
          <strong>Employee Access:</strong> Scan QR code to access training form directly
        </div>
      </div>
    </div>
  );
}

export default Login;
